export default __webpack_public_path__ + "b55f63c26585096184630183e85ed89f.png";